// extracted by mini-css-extract-plugin
export default {"fullWidth":"Wm-z","image":"Xm-z","lazyLoadPicture":"Ym-z","lazyLoadSpinner":"Zm-z","lazyLoadSpin":"_m-z","lazyLoadImage":"an-z","hasStyledAspectRatio":"bn-z"};